import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import {
  AuthLayoutSubTitle,
  AuthLayoutTitle
} from '../../styles/GlobalComponents';
import Spinner from '../../components/common/Spinner';
import {
  getReferrerUsernameValidation,
  getReferrerValidation
} from './Referral.actions';
import { LOGIN } from '../../routes/routes';

const captchaId = process.env.REACT_APP_CAPTCHA_ID;

const Referral = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');
  const dispatch = useAppDispatch();

  const { loading } = useAppSelector((state) => state.auth);

  const [referrerId, setReferrerId] = useState('');
  const [username, setUsername] = useState('');

  const [captchaLoading, setCaptchaLoading] = useState(false);

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setCaptchaLoading(true);
    window?.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const result = captcha.getValidate();

            if (referrerId && !username) {
              dispatch(
                getReferrerValidation({
                  referrerId: Number(referrerId),
                  result,
                  history
                })
              );
            } else if (!referrerId && username) {
              dispatch(
                getReferrerUsernameValidation({
                  username,
                  result,
                  history
                })
              );
            }
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  const onHandleSubmitNoReferrer = (e: any) => {
    e.preventDefault();

    setCaptchaLoading(true);
    window?.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const result = captcha.getValidate();
            dispatch(
              getReferrerValidation({
                referrerId: null,
                result,
                history
              })
            );
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  return (
    <>
      {loading || (captchaLoading && <Spinner fullScreen={true} transparent />)}

      <AuthLayoutTitle>Sign up</AuthLayoutTitle>
      <AuthLayoutSubTitle center pointer style={{ marginBottom: '30px' }}>
        Who Referred You?
      </AuthLayoutSubTitle>

      <form onSubmit={onHandleSubmit}>
        {/* SPONSOR ID */}
        <InputBackOffice
          id={'referral'}
          type={'number'}
          placeholder={'Sponsor ID'}
          name={'referral'}
          value={referrerId}
          onChange={(value: any) => {
            setReferrerId(value);
            if (value) setUsername(''); // auto-clear username
          }}
          disabled={!!username} // disable when username is entered
          label={t('referral.label')}
          style={{ marginBottom: '20px' }}
        />

        {/* SPONSOR USERNAME */}
        <InputBackOffice
          id={'username'}
          type={'text'}
          placeholder={'Sponsor Username'}
          name={'username'}
          value={username}
          onChange={(value: any) => {
            setUsername(value);
            if (value) setReferrerId(''); // auto-clear sponsor ID
          }}
          disabled={!!referrerId} // disable when sponsor ID is entered
          label={t('referral.label')}
          style={{ marginBottom: '0px' }}
        />

        <Button type='button' textButton onClick={onHandleSubmitNoReferrer}>
          Don’t have a sponsor username/ID
        </Button>

        <Button
          mb='10'
          type='submit'
          disabled={!referrerId && !username}
          negative>
          Continue
        </Button>

        <Button type='button' negative onClick={() => history.push(LOGIN)}>
          I already have an account
        </Button>
      </form>
    </>
  );
};

export default Referral;
